module.exports = __webpack_public_path__ + "static/beneficio-4-ac27bcb7cb7815d26ea4d6773e0d5fb8.png";